import Component from "@lib/Component";

class Factory {
  constructor() {
    this.components = {};
  }

  matchComponent(key, classRef) {
    this.components[key] = classRef;

    return this;
  }

  matchComponents(components) {
    this.components = {
      ...this.components,
      ...components
    };

    return this;
  }

  createComponent(el, datas) {
    const componentId = el.dataset && el.dataset.component;
    let componentInstance;

    if (!this.components[componentId]) {
      componentInstance = new Component({
        ...datas,
        el,
        id: componentId
      });
    } else {
      componentInstance = new this.components[componentId]({
        ...datas,
        el,
        id: componentId
      });
    }

    return componentInstance;
  }
}

export default new Factory();



// WEBPACK FOOTER //
// ./scripts/lib/Factory.js